import { Routes, Route } from 'react-router-dom';
import { Dashboard } from '../dashboard/Dashboard';
import { ErrorBoundary } from '../error/ErrorBoundary';
import { OrganizationSettings } from '../../pages/settings/OrganizationSettings';

export function DashboardLayout() {
  return (
    <div className="min-h-screen w-full bg-background">
      <main className="w-full">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="settings/organization" element={<OrganizationSettings />} />
            {/* Add more dashboard routes here */}
          </Routes>
        </ErrorBoundary>
      </main>
    </div>
  );
}